import Logo from "static/img/logo-white.svg";

const data = {
    logoPhone: {
        img: Logo,
        phone: "(021) 22984722",
    },
    sitemap: {
        label: "Sitemap",
        menu: [{ url: "/", text: "Home" },
        { url: "/info-perusahaan", text: "Info Perusahaan" },
        { url: "/info-layanan", text: "Info Layanan" },
        { url: "/berita", text: "Berita" },
        { url: "/galeri", text: "Galeri" },
        { url: "/kontak", text: "Hubungi Kami" }]
    },
    linkRelated: {
        label: "Link Terkait",
        menu: [{ url: "https://cim.jmto.co.id", text: "Corporate Internal Media (CIM)" },
        { url: "https://eprocurement.jmto.co.id", text: "E-PROCUREMENT JMTO" }]
    },
    address: {
        label: "Alamat Kami",
        html: "Gedung Cabang Jagorawi Lt. 4<br>Plaza Tol Taman Mini Indonesia Indah<br>Jakarta, 13550 Indonesia<br>Telp. (021) 22984722"
    },
    bottomContent:
    {
        label: "© PT Jasamarga Tollroad Operator.",
        menu: [{ url: "https://jmto.co.id", text: "Privacy & Policy" }]
    }
}
const { logoPhone, sitemap, linkRelated, address, bottomContent } = data
export default () => (
    <div className="bg-primary p-4">
        <div className="container" style={{ paddingTop: "50px" }}>
            <div className="d-flex justify-content-between">
                <div style={{width:"35%"}} className="d-flex justify-content-between logo-phone">
                    <div className="mr-4">
                        <div><img src={logoPhone.img} /></div>
                        <div className="py-3" />
                        <div>
                            <a className="text-white" href="#">
                                <h6 className="font-weight-light">{logoPhone.phone}</h6>
                            </a>
                        </div>
                    </div>
                    <div className="text-white d-none d-xl-block">
                        <div className="mb-3"><h6 className="font-weight-light">{sitemap.label}</h6></div>
                        <div>
                            <ul className="list-unstyled">
                                {sitemap.menu.map((item, key) => (
                                    <li key={key}>
                                        <a className="text-white" href={item.url}><small>{item.text}</small></a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                <div style={{width:"52%"}} className="d-flex justify-content-between lnk-related">
                    <div className="text-white" style={{maxWidth:"250px"}}>
                        <div className="mb-3"><h6 className="font-weight-light">{linkRelated.label}</h6></div>
                        <div className="list-circle">
                            <ul className="list-unstyled">
                                {linkRelated.menu.map((item, key) => (
                                    <li className="position-relative" key={key}>
                                        <a className="text-white" href={item.url} target="_blank"><small>{item.text}</small></a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="text-white">
                        <div className="mb-3"><h6 className="font-wight-light">{address.label}</h6></div>
                        <div>
                            <small dangerouslySetInnerHTML={{ __html: address.html }}>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
            <hr className="border-white" />
            <div className="d-flex justify-content-between">
                <div className="text-white">
                    <small className="font-weight-light">{bottomContent.label}</small>
                </div>
                <div>
                    <ul className="list-unstyled list-inline m-0">
                        {bottomContent.menu.map((item, key) => (
                            <li className="list-inline-item" key={key}>
                                <a className="text-white" href={item.url}><small>{item.text}</small></a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
        <style jsx>
            {`
            @import './styles/jmto-custom';
            .list-circle ul{
                margin-left:1em;
            }
            .list-circle ul li::before {
                content: '';
                border-radius:50%;
                background-color: $yellow; 
                font-weight: bold; 
                display: inline-block; 
                width: 7px;
                height:7px; 
                margin-right: .5em;
                margin-left: -1em;
            }
            @media (max-width: 991.98px) {
                .logo-phone{
                   width:20% !important;
                }
                .lnk-related{
                    width:70% !important;
                }
            }
            @media (max-width: 767.98px) {
                .container{
                    padding-top:20px !important;
                }
                .d-flex{
                    display:block !important;
                    text-align:center;
                    width:100% !important;
                }
                .mr-4{
                    margin-right: 0 !important;
                }
                .text-white{
                    max-width: 100% !important;
                }
            }
            `}
        </style>
    </div >
)